import React, { Component } from "react";
import PropTypes from "prop-types";

export default class Feature extends Component {
  render = () => {
    const spanStyle = {
      lineHeight: "1.2em",
      paddingTop: "1.2em",
      ...this.props.style,
    };
    const divStyle = { height: "inherit", minHeight: "40px" };

    return (
      <div>
        <div className="label-right">
          <span>{this.props.featureName}</span>
          <div style={divStyle}>
            <span className="linked-service-value" style={spanStyle}>
              {this.props.displayValue}
            </span>
          </div>
        </div>
      </div>
    );
  };
}

Feature.propTypes = {
  style: PropTypes.object,
  featureName: PropTypes.string,
  displayValue: PropTypes.string,
};
